import { observable, action } from 'mobx';
import { deepCopy } from '../../js/utils';

const defaultProjectParam = {
  version: {
    name: '版本号',
    origin_value: '',
    value: ''
  }, // 硬件版本
  communicateType: {
    name: '通讯类型',
    origin_value: '',
    value: ''
  }, // 通讯类型 01---NB；02---LoRa
  operator: {
    name: '运营商',
    origin_value: '',
    value: ''
  }, // 运营商 00---中国联通 01---中国电信 02---中国移动
  detectType: {
    name: '检测方式',
    origin_value: '',
    value: []
  } // 检测方式 1
};

const defaultRf = {
  IMEI: '',
  IMSI: '',
  ICCID: '',
  MODE: '', // 地磁模式 00正常 80低电量 81网络异常
  MODETIME: '' // 进入地磁模式的时间
};

export default class ReadStore {
  @observable status = 'loading';

  @observable RFID = '';

  @observable projectId = '';

  // 项目夜间模式配置
  @observable nightModeInfo = {
    projectId: '',
    startTime: '23:00:00',
    endTime: '07:00:00',
    status: 0
  }

  @observable projectParam = deepCopy(defaultProjectParam);

  @observable rf = deepCopy(defaultRf);

  @action setStatus(status) {
    this.status = status;
  }

  @action setManufacturer(data) {
    this.RFID = this.RFID.replace(/^\w{2}/, data);
  }

  @action setProjParam(key, param) {
    this.projectParam[key].origin_value = param.origin_value;
    this.projectParam[key].value = param.value;
  }

  @action getProjParam(key) {
    return this.projectParam[key].value;
  }

  @action isNB() {
    return this.projectParam.communicateType.value === 'NB';
  }

  @action isLoRa() {
    return this.projectParam.communicateType.value === 'LORA';
  }

  @action reset() {
    this.status = 'loading';
    this.projectParam = deepCopy(defaultProjectParam);
    this.RFID = '';
    this.rf = deepCopy(defaultRf);
  }
}

export const readStore = new ReadStore();
